<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 01/01/2019
  -->

<template>


	<div class="fill-height-container card mb-3 event-settings-root">


		<div v-if="eventType" @mouseup="clearFormValidationInternal()" class="qwoach-form expand-error">
			<!--			<div v-sticky on-stick="onSaveIsSticky" :class="{'sticked': isSaveButtonSticked}">-->
			<div>
				<div class="row mx-0 px-4 ">

					<div class="layout-spacer"/>

					<SaveButton @click="submitFormInternal"
								size="small"
								class="my-3 mr-2"/>

					<OptionsMenu
						ref="optionsMenu"
						v-if="!hideMenu"
						:menuItems="menuItems"
						@menuClicked="menuClicked"
						@click="onMenuItemClicked"/>
				</div>
				<hr/>
			</div>
			<el-form :model="eventType" :rules="rules" ref="mainForm" class="p-3">

				<FormNumberRow
					prop="eventBufferBefore"
					title="Buffer before"
					class="mb-3"
					tooltipPosition="title"
					:isVertical="isVertical"
					titlePostfix="minutes"
					:tooltip-analytics-props="{label:'Buffer before', ...this.analyticsPropsMethod()}"
					tooltipText="Use this setting to let Qwoach ensure free/preparation time before each session."
					:labelMinWidth="labelMinWidth"
					:formatDataInProp="formatDataInMinutes"
					:formatDataOutProp="formatDataOutMinutes"
					:input-debounce-delay="inputDebounceDelay"
					@change="valueChanged('Buffer before')"
					v-model="eventType.eventBufferBefore"/>

				<FormNumberRow
					prop="eventBufferAfter"
					title="Buffer after"
					class="mb-3"
					tooltipPosition="title"
					:isVertical="isVertical"
					titlePostfix="minutes"
					:tooltip-analytics-props="{label:'Buffer after', ...this.analyticsPropsMethod()}"
					tooltipText="Use this setting to let Qwoach ensure free/preparation time after each session."
					:labelMinWidth="labelMinWidth"
					:formatDataInProp="formatDataInMinutes"
					:formatDataOutProp="formatDataOutMinutes"
					:input-debounce-delay="inputDebounceDelay"
					@change="valueChanged('Buffer after')"
					v-model="eventType.eventBufferAfter"/>

				<FormNumberRow
					prop="minSchedulingNotice"
					title="Accept sessions"
					class="mb-3"
					tooltipPosition="title"
					:isVertical="isVertical"
					titlePostfix="days into the future"
					:tooltip-analytics-props="{label:'Rolling days', ...this.analyticsPropsMethod()}"
					tooltipText="Set how far into the future you want to accept sessions."
					:labelMinWidth="labelMinWidth"
					:formatDataInProp="formatDataInDays"
					:formatDataOutProp="formatDataOutDays"
					:input-debounce-delay="inputDebounceDelay"
					@change="valueChanged('Minimal notice')"
					v-model="eventType.rollingDays"/>


				<FormNumberRow
					prop="minSchedulingNotice"
					title="Minimal notice"
					class="mb-3"
					tooltipPosition="title"
					:isVertical="isVertical"
					titlePostfix="hours away"
					:tooltip-analytics-props="{label:'Minimal notice', ...this.analyticsPropsMethod()}"
					tooltipText="Use this option to prevent last minute sessions."
					:labelMinWidth="labelMinWidth"
					:formatDataInProp="formatDataInHours"
					:formatDataOutProp="formatDataOutHours"
					:input-debounce-delay="inputDebounceDelay"
					@change="valueChanged('Minimal notice')"
					v-model="eventType.minSchedulingNotice"/>

				<FormNumberRow
					prop="maxEventsPerDay"
					title="Max per day"
					class="mb-3"
					tooltipPosition="title"
					:isVertical="isVertical"
					:titlePostfix="sessionText"
					:formatDataInProp="formatInMaxEventsPerWeekOrDay"
					:tooltip-analytics-props="{label:'Max per day', ...this.analyticsPropsMethod()}"
					tooltipText="Limit how many sessions you can have per day.<br/><br/>Leave blank to remove limits."
					:labelMinWidth="labelMinWidth"
					:input-debounce-delay="inputDebounceDelay"
					@change="valueChanged('Max per day')"
					v-model="eventType.maxEventsPerDay"/>

				<FormNumberRow
					prop="maxEventsPerWeek"
					title="Max per week"
					class="mb-3"
					tooltipPosition="title"
					:isVertical="isVertical"
					:titlePostfix="sessionText"
					:formatDataInProp="formatInMaxEventsPerWeekOrDay"
					:tooltip-analytics-props="{label:'Max per week', ...this.analyticsPropsMethod()}"
					tooltipText="Limit how many sessions you can have per week.<br/><br/>Leave blank to remove limits."
					:labelMinWidth="labelMinWidth"
					:input-debounce-delay="inputDebounceDelay"
					@change="valueChanged('Max per week')"
					v-model="eventType.maxEventsPerWeek"/>

				<FormNumberRow
					prop="increments"
					title="Availability increment"
					class="mb-3"
					tooltipPosition="title"
					:isVertical="isVertical"
					:tooltip-analytics-props="{label:'Availability increment', ...this.analyticsPropsMethod()}"
					titlePostfix="minutes"
					tooltipText="Set the frequency of available time slots for your invitees."
					:labelMinWidth="labelMinWidth"
					:formatDataInProp="formatDataInMinutes"
					:formatDataOutProp="formatDataOutMinutes"
					:input-debounce-delay="inputDebounceDelay"
					@change="valueChanged('Availability increment')"
					v-model="eventType.increments"/>

				<hr/>

				<div class="form-padding py-3 mt-4 bold">Workflows</div>

				<div v-if="attachedWorkflows">

					<div v-for="(workflow, index) of attachedWorkflows" :key="'workflow_' + index">
						<FormRow
							:is-vertical="true"
							:title="workflow.title">
							<RemindersWorkflowView
								ref="workflowReminders"
								:readonly="true"
								:email-reminders="workflow.emailReminders"
								@emailReminderDirectionChanged="emailReminderDirectionChanged"
								@onEmailReminderDeleteClicked="onEmailReminderDeleteClicked"
								@valueChanged="onWorkflowValueChanged(workflow)"/>
						</FormRow>
<!--						<hr/>-->
					</div>


				</div>

				<!--				{{attachedWorkflows}}-->
				<FormRow
					prop="isEmailReminderEnabled"
					title="Add custom reminders and follow ups"
					class=""
					v-if="eventType.isEmailReminderEnabledCanEdit"
					tooltipPosition="title"
					:isVertical="isVertical"
					titlePostfix="minutes"
					:tooltip-analytics-props="{label:'Enable email reminder', ...this.analyticsPropsMethod()}"
					tooltipText="Use it to schedule emails before session starts, like reminders, welcome emails, surveys, share materials as well as follow up emails after the session completes."
					:labelMinWidth="labelMinWidth">
					<div class="row mx-0">


						<el-checkbox

							v-model="eventType.isEmailReminderEnabled"
							@change="valueChanged('Email reminder enabled', {value: eventType.isEmailReminderEnabled})">
						</el-checkbox>

					</div>

				</FormRow>

				<div class="px-0 my-4" v-if="eventType.isEmailReminderEnabled">


					<RemindersWorkflowView
						ref="workflowReminders2"
						:email-reminders="eventType.emailReminders"
						@emailReminderDirectionChanged="emailReminderDirectionChanged"
						@onEmailReminderDeleteClicked="onEmailReminderDeleteClicked"
						@valueChanged="valueChanged"
						@onAddEmailClicked="onAddEmailClicked"
					/>

				</div>
				<hr/>
				<div class="form-padding py-3 mt-4">Cancellation policy</div>


				<FormCheckboxRow
					prop="isCancellationPolicyEnabled"
					title="Enable cancellation policy"
					class="mb-3"
					tooltipPosition="title"
					:isVertical="isVertical"
					titlePostfix="minutes"
					:tooltip-analytics-props="{label:'Enable cancellation policy', ...this.analyticsPropsMethod()}"
					tooltipText="Prevent last minute cancellation or reschedule by enabling your cancellation policy."
					:labelMinWidth="labelMinWidth"
					@change="valueChanged('Enable cancellation policy', {value: eventType.isCancellationPolicyEnabled})"
					v-model="eventType.isCancellationPolicyEnabled"/>

				<div v-if="eventType.isCancellationPolicyEnabled">

					<FormNumberRow
						prop="minimumCancellationNotice"
						title="Minimum cancellation notice"
						class="mb-3"
						tooltipPosition="title"
						:isVertical="isVertical"
						titlePostfix="hours before session starts"
						tooltipText="Customize your cancellation policy. <br/><br/>Specify minimal notice after which your invitees are not allowed to cancel or reschedule the session."
						:tooltip-analytics-props="{label:'Minimum cancellation notice', ...this.analyticsPropsMethod()}"
						:labelMinWidth="labelMinWidth"
						:formatDataInProp="formatDataInHours"
						:formatDataOutProp="formatDataOutHours"
						:input-debounce-delay="inputDebounceDelay"
						@change="valueChanged('Minimum cancellation notice')"
						v-model="eventType.minimumCancellationNotice"/>

					<FormEditorRow
						prop="cancellationPolicyDescription"
						class="mb-3"
						tooltipPosition="title"
						:isVertical="isVertical"
						:multiline="true"
						:analytics-props="analyticsPropsMethod()"
						:labelMinWidth="labelMinWidth"
						:minRows="4"
						title="Policy Description"
						:tooltip-analytics-props="{label:'Policy Description', ...this.analyticsPropsMethod()}"
						placeholder="Policy description (optional)"
						tooltipText="You can add your cancellation policy details or paste a link to your policy here. <br/><br/>It's optional."
						:input-debounce-delay="inputDebounceDelay"
						@change="valueChanged('Cancellation policy Description')"
						v-model="eventType.cancellationPolicyDescription"/>
				</div>

				<!--								<hr/>-->
				<!--								<div class="form-padding py-3 mt-4">Collect payments</div>-->

				<!--								<FormNumberRow-->
				<!--									prop="price"-->
				<!--									title="Price"-->
				<!--									class="mb-3"-->
				<!--									tooltipPosition="title"-->
				<!--									:isVertical="isVertical"-->
				<!--									:titlePrefix="currencyItemGlobal.currencySign"-->
				<!--									:titlePostfix="currencyItemGlobal.currencyCode"-->
				<!--									tooltipText="Set the price for this session - your invitees will be asked to pay before completing the booking. <br/><br/> Set to 0.00 to remove any mentions of the price for your invitees."-->
				<!--									:labelMinWidth="labelMinWidth"-->
				<!--									v-model="eventType.price"/>-->

				<!--								<div v-if="!this.paymentIntegrations.hasIntegrations()" class="form-padding">-->
				<!--									<a href="#" @click.prevent="showPaymentMethodsOptions = true">Click here</a> to setup payment integration before you can accept payments.-->
				<!--								</div>-->

			</el-form>
		</div>

		<qw-drawer
			v-if="showPaymentMethodsOptions"
			v-model="showPaymentMethodsOptions"
			custom-class="bg-app-primary"
			size="80%"
			direction="rtl">

			<PaymentMethodsView
				:paymentIntegrations="paymentIntegrations"/>
		</qw-drawer>


		<LoadingIndicator :text="progressText"
						  v-if="isDataLoading"
						  class="center-fixed"/>

		<SavingNotification ref="savingNotification"/>


		<!--		<el-button @click="showSavingIndicator">Show</el-button>-->
	</div>


</template>
<style>

</style>

<script>

import LocationChooser from "@/core/components/LocationChooser/LocationChooser"

import LoadingIndicator from "@/core/components/LoadingIndicator.vue";
import QwInput from "@/core/components/Controls/QwInput.vue";
import FormTextRow from "@/core/components/Form/FormTextRow.vue";
import FormRow from "@/core/components/Form/Base/FormRow.vue";
import FormNumberRow from "@/core/components/Form/FormNumberRow.vue";
import FormEditorRow from "@/core/components/Form/FormEditorRow.vue";
import SavingNotification from "@/core/components/Notifications/SavingNotification.vue";
import SaveButton from "@/core/components/Controls/Buttons/SaveButton.vue";
import FormCheckboxRow from "@/core/components/Form/FormCheckboxRow.vue";
import PaymentMethodsView from "@/core/modules/coach/Billing/view/PaymentIntegrations/PaymentMethodsView.vue";
import OptionsMenu from "@/core/components/Menu/OptionsMenu.vue";
import {MenuAction} from "@/core/modules/coach/Resources/Files/QwoachDrive/MenuAction";
import MenuItem from "@/core/modules/coach/Resources/Files/QwoachDrive/MenuItem";
import SessionTypeHelper from "@/core/modules/coach/Scheduler/EventTypes/Settings/SessionTypeHelper";

import BaseComponent from "@/core/components/BaseComponent.vue";
import EmailTemplateComposer from "@/core/components/template/EmailTemplateComposer.vue";
import EmailReminderItem from "@shared/scheduler/reminders/EmailReminderItem";
import PaymentIntegrations from "@shared/Billing/PaymentIntegrations";
import EventType from "@shared/scheduler/EventType";
import {isLinkValid} from "@/utils/helpers";
import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";
import FormSelectRow from "@/core/components/Form/FormSelectRow.vue";

import {deleteConfirmDialog} from "@/core/components/Dialogs/dialog"
import ClientPickerView from "@/core/components/Picker/ClientPickerView/ClientPickerView.vue";
import RemindersWorkflowView from "@/core/modules/coach/Scheduler/EventTypes/Settings/RemindersWorkflowView.vue";

export default {
	extends: BaseComponent,
	name: "EventTypeAdditionalSettingsView",
	components: {
		RemindersWorkflowView,
		ClientPickerView,
		FormSelectRow,
		ToolTipView,
		EmailTemplateComposer,
		OptionsMenu,
		PaymentMethodsView,
		FormCheckboxRow,
		SaveButton,
		SavingNotification,
		FormEditorRow,
		FormNumberRow,
		FormRow,
		FormTextRow,
		QwInput,
		LoadingIndicator,
		LocationChooser
	},
	props: {
		paymentIntegrations: PaymentIntegrations,
		eventType: EventType,
		backRouteName: String,
		hideMenu: Boolean,
		hideToast: Boolean,
		tooltipAnalyticsProps: Object,
	},
	watch: {
		eventType: {
			immediate: true,
			handler() {
				this.displayNameInitial = this.eventType.displayName
				this.onEventTypeChanged()
			}
		}
	},
	data() {
		return {
			attachedWorkflows: [],
			inputDebounceDelay: 1000,
			displayNameInitial: null,
			showEmailNotificationPersonalization: false,
			linkChanged: false,
			showPaymentMethodsOptions: false,
			isSaveButtonSticked: false,
			isVertical: false,
			labelMinWidth: 200,
			sessionTypeHelper: null,
			rules: {
				displayName: [
					{
						required: true,
						whitespace: false,
						message: 'Please choose a name for this session type',
						trigger: 'validate'
					},
				],
				displayId: [
					{
						required: true,
						whitespace: false,
						validator: async (rule, value, callback, source, options) => {

							let error;
							if (value.length === 0) {
								error = 'Please choose a link for this session'
							} else if (!this.eventType.isCategoryProgram() && !isLinkValid(value)) {
								error = "Invalid link. Please use only lowercase 'a-z', '0-9', '-', or '_' characters."
							} else if (this.linkChanged) {
								let eventType = await this.$dataManager.apiGetEventTypePublic({
									eventTypeUserId: this.userProfile.schedulerSettings.eventTypeUserId,
									eventTypeId: value
								})
								if (eventType) {
									error = `This link is already taken. Please use a different link.`
								} else {
									this.linkChanged = false
								}
							}
							callback(error);
						},
						trigger: 'validate'
					},
				],
				rollingDays: [
					{
						validator: (rule, value, callback, source, options) => {
							let error;
							if (value.length === 0) {
								error = 'Date range is required'
							} else if (this.eventType.rollingDays < 1) {
								error = `Date range should be at least 1 day`
							}
							callback(error);
						},
						trigger: 'validate'
					},
				],
				duration: [
					{
						validator: (rule, value, callback, source, options) => {
							let error;
							if (value.length === 0) {
								error = 'Duration is required'
							} else if (this.eventType.duration > 12 * 60 * 60 * 1000) {
								error = `Duration should be less than 12 hours (${12 * 60} minutes)`
							} else if (this.eventType.duration < 5 * 60 * 1000) {
								error = `Duration should be at least 5 minutes`
							}
							callback(error);
						},
						trigger: 'validate'
					}
				],
				increments: [
					{
						validator: (rule, value, callback, source, options) => {
							console.log("value11 = ", value)
							let error;
							if (!value) {
								error = 'Increment is required'
							} else if (value < 5 * 60 * 1000) {
								error = `Increment should be at least 5 minutes`
							}
							callback(error);
						},
						trigger: 'validate'
					}
				],
				maxEventsPerWeek: [
					{
						validator: (rule, value, callback, source, options) => {
							let error;
							console.log("this.eventType.maxEventsPerWeek = ", this.eventType.maxEventsPerWeek)
							console.log("this.eventType.maxEventsPerDay = ", this.eventType.maxEventsPerDay)
							console.log("this.eventType.maxEventsPerWeek < this.eventType.maxEventsPerDay = ", this.eventType.maxEventsPerWeek < this.eventType.maxEventsPerDay)
							console.log("typeof maxEventsPerWeek = ", typeof this.eventType.maxEventsPerWeek)
							console.log("typeof maxEventsPerDay = ", typeof this.eventType.maxEventsPerDay)
							console.log("this.eventType.maxEventsPerWeek < this.eventType.maxEventsPerDay = ", this.eventType.maxEventsPerWeek < this.eventType.maxEventsPerDay)
							console.log("value = ", value)
							if (this.eventType.maxEventsPerWeek && this.eventType.maxEventsPerWeek < this.eventType.maxEventsPerDay) {
								error = `Max sessions per week can't be less than max sessions per day`
							}
							callback(error);
						},
						trigger: 'validate'
					}
				],
				minimumCancellationNotice: [
					{
						validator: (rule, value, callback, source, options) => {
							let error;
							if (value < 60 * 60 * 1000) {
								error = `Must be at least 1 hour`
							}
							callback(error);
						},
						trigger: 'validate'
					}
				]

			}
		};
	},
	created() {
		console.log("SchedulerGeneralSettings created111")
		this.sessionTypeHelper = new SessionTypeHelper(this)

	},


	methods: {

		async onEventTypeChanged() {
			// //We no longer send IAOTRC workflow documents as per the organization's requirements
			if (this.eventType.attachedWorkflowIds && this.eventType.attachedWorkflowIds.length > 0) {
				let workflowPromises = this.eventType.attachedWorkflowIds.map(workflowId => this.dataManager.getWorkflowItem(workflowId))
				let res = await this.handleAsync(workflowPromises)
				if (res) {
					this.attachedWorkflows = res
				}
			}
		},
		async onWorkflowValueChanged(workflowItem){
			// await this.handleAsyncNonBlocking(this.dataManager.updateWorkflowItem(workflowItem))
		},

		async tabBeforeLeave() {
			// return await yesNoDialog("Switch tab?", "You sure??", "Yes", "No", true)
		},


		onLinkKeyDown(event) {
			// TODO add logic to automatically substitute incorrect characters as user is typing
			// like " "->"-", "A"->"a" etc.
		},
		onLinkChanged() {
			console.log("onLinkChanged")
			this.linkChanged = true
			this.valueChanged("session link")
		},

		async validateFormCustom() {
			let [res1, res2] = await Promise.all([
				this.validateForm(),
				this.validateWorkflowReminders(),
			])
			let isValid = res1 && res2
			if (!isValid) {
				this.toastWarn("Some required fields are not set.")
			}
			return isValid
		},

		async validateWorkflowReminders(){
			console.log("this.$refs.workflowReminders : ", this.$refs.workflowReminders )
			let reminders1 = this.$refs.workflowReminders
			let reminders2 = this.$refs.workflowReminders2
			reminders1 = Array.isArray(reminders1) ? reminders1[0] : reminders1
			reminders2 = Array.isArray(reminders2) ? reminders2[0] : reminders2
			console.log("validateWorkflowReminders : reminders1 = ", reminders1, ", reminders2 = ", reminders2)
			let [res1, res2] = await Promise.all([
				reminders1 ? reminders1.validateFormRes() : true,
				reminders2 ? reminders2.validateFormRes() : true,
			])
			return res1 && res2
		},

		async submitFormInternal() {
			let _ = this.$analyticManager.trackEvent("Save clicked", this.analyticsPropsMethod())
			let isValid = await this.validateFormCustom()
			if (isValid) {
				await this.updateEventType()
				if (!this.hideToast) this.toast("Updated successfully")
				this.$emit("onSaved", this.eventType)
			}
			return isValid
		},

		onAddEmailClicked() {
			let reminderTitle = `Email reminder ${this.eventType.emailReminders.length + 1}`
			let emailReminder = new EmailReminderItem("", "", reminderTitle)
			emailReminder._isPersonalizationShowing = true
			this.eventType.emailReminders.push(emailReminder)
		},

		clearFormValidationInternal() {
			this.clearFormValidation()
		},

		formatDataInMinutes(buffer) {
			return buffer / (60 * 1000)
		},

		formatDataOutMinutes(buffer) {
			return buffer * (60 * 1000)
		},

		formatDataInHours(buffer) {
			return buffer / (60 * 60 * 1000)
		},

		formatDataOutHours(buffer) {
			return buffer * (60 * 60 * 1000)
		},

		formatDataInDays(buffer) {
			return buffer / (24 * 60 * 60 * 1000)
		},

		formatDataOutDays(buffer) {
			return buffer * (24 * 60 * 60 * 1000)
		},

		formatInMaxEventsPerWeekOrDay(value) {
			return value ? value : ""
		},

		onReminderBaseValueChanged(reminder) {
			this.reminderOptions = this.reminderOptions.map(option => {
				if (option.label.endsWith('s')) {
					option.label = option.label.substring(0, option.label.length - 1);
				}
				if (reminder.trigger.shiftBaseAmount !== 1) {
					option.label = option.label + 's'
				}
				return option
			})
		},

		emailReminderDirectionChanged(reminder) {
			console.log("emailReminderDirectionChanged: direction = ", reminder.trigger.shiftDirection)
			let title = reminder.title
			if (reminder.trigger.isFollowup()) {
				title = title.replace("reminder", "follow up")
			} else {
				title = title.replace("follow up", "reminder")
			}
			reminder.title = title
			this.recalculateEmailRemindersExtraShift()
		},

		async onEmailReminderDeleteClicked(index) {
			let options = {
				itemName: "email"
			}
			if (index > 0 && await deleteConfirmDialog(options)) {
				this.eventType.emailReminders.splice(index, 1)
			}
		},

		onDurationChanged() {
			this.recalculateEmailRemindersExtraShift()
			this.valueChanged('Duration')
		},

		valueChanged(title, props = {}) {
			this.$analyticManager.trackEvent("Value changed", {label: title, ...this.analyticsPropsMethod(), ...props})
		},

		recalculateEmailRemindersExtraShift() {
			for (let reminder of this.eventType.emailReminders) {
				if (reminder.trigger.isFollowup()) {
					reminder.trigger.extraShiftAmountMs = this.eventType.duration
				} else {
					reminder.trigger.extraShiftAmountMs = 0
				}
			}
		},


		openLinkClicked() {
			this.$analyticManager.trackEvent("Open scheduling link clicked", this.analyticsPropsMethod())
		},

		togglePersonalizationShow() {
			this.showEmailNotificationPersonalization = !this.showEmailNotificationPersonalization
			this.valueChanged("Personalization email show", {value: this.showEmailNotificationPersonalization})
		},

		async startIntegrationClicked() {
			await this.updateEventType()
		},

		async copyLink() {
			let _ = this.$analyticManager.trackEvent("Copy scheduling link clicked", this.analyticsPropsMethod())
			let link = this.sessionFullUrlComputed
			try {
				await this.$copyText(link)
				this.toast("Link copied to clipboard.")
			} catch (error) {
				this.handleError(error)
			}
		},

		async loadSessionType() {
			let promise = Promise.all([
				this.$dataManager.apiGetEventType({sessionTypeId: this.eventTypeId, coachId: this.getCoachId()}),
				// this.$dataManager.getPaymentIntegrationsMain(),
			])
			let [eventType, paymentIntegrations] = await this.handleAsync(() => promise)

			this.eventType = eventType
			this.displayNameInitial = eventType.displayName

			this.paymentIntegrations = paymentIntegrations
		},

		async onDeleteClicked() {
			try {
				await this.$dataManager.deleteEventType(this.eventTypeId)
				this.onBackPressed()
			} catch (error) {
				this.handleError(error)
			}
		},

		onSaveIsSticky(res) {
			this.isSaveButtonSticked = res.sticked
			if (this.$refs.optionsMenu) {
				this.$refs.optionsMenu.showPopup(false)
			}
		},

		async updateEventType() {
			if (this.displayNameInitial !== this.eventType.displayName) {
				this.displayNameInitial = this.eventType.displayName
			}
			if (this.eventType.isEmailReminderEnabled) {
				this.eventType.emailReminder = this.emailReminderData
			}
			// this.eventType.needsSetup = false
			await this.$dataManager.setEventType(this.eventType)
			// try {
			// 	this.savingNotification.show()
			// 	await this.$dataManager.updateEventType(this.eventType)
			// 	await this.savingNotification.hideSuccess()
			// } catch (error) {
			// 	await this.savingNotification.hideFailed()
			// 	this.handleError(error)
			// }
		},

		menuClicked() {
			let _ = this.$analyticManager.trackEvent("Menu clicked", this.analyticsPropsMethod())
		},

		async onMenuItemClicked(action) {
			console.log("Session type: onMenuItemClicked = ", action)
			let actionPromise = Promise.resolve()
			let _ = this.$analyticManager.trackEvent("Menu item clicked", {action: action, ...this.analyticsPropsMethod()})

			switch (action) {
				case MenuAction.COPY:
					actionPromise = this.copySession()
					break
				case MenuAction.DELETE:
					actionPromise = this.deleteSession()
					break
			}

			return this.handleAsync(() => actionPromise)
		},

		async copySession() {
			let isValid = await this.validateFormCustom()
			if (isValid) {
				await this.updateEventType()
				await this.sessionTypeHelper.copySessionType(this.eventType)
				this.toast("Session type was copied successfully")
				await this.go(this.backRouteName)
			}
		},

		async deleteSession() {
			let isDeleted = await this.sessionTypeHelper.deleteSessionType(this.eventType)
			if (isDeleted) {
				this.toast("Session type was deleted successfully")
				await this.go(this.backRouteName)
			}
		},

		analyticsPropsInternal() {
			return {
				category: "Session type settings",
				session_type_id: this.eventType.id
			}
		}

	},
	computed: {

		emailReminderData: {
			get: function () {
				return this.eventType.emailReminder || new EmailReminderItem()
			},
			set: function (reminder) {
				this.eventType.emailReminder = reminder
			}
		},


		sessionFullUrlComputed() {
			return this.sessionFullUrl(this.eventType)
		},

		isSetupCompleted() {
			return this.userProfile.schedulerSettings.isSetupCompleted;
		},

		sessionText() {
			return this.eventType.maxEventsPerDay === 1 ? "session" : "sessions"
		},

		savingNotification() {
			return this.$refs.savingNotification
		},

		billingSectionUrl() {
			return this.resolvePathByRouteName("billingRoot")
		},


		menuItems() {
			return [
				MenuItem.createDuplicateItem(),
				MenuItem.createDeleteItem(),
			]
		}
	}


}
</script>

<!--<style src="../Scheduler.scss" lang="scss" scoped/>-->



<style lang="scss">

.event-settings-root {
	.sticked {
		background: white;
		//border-bottom: 1px solid;
	}

	.reminder-error-padding {
		.el-form-item__error {
			padding-top: 15px;
			padding-left: 170px;
		}
	}
}

/*.error-padding .el-form-item__error {*/
/*	padding-left: 150px !important;*/
/*}*/

/*.error-padding__10 .el-form-item__error {*/
/*	padding-left: 10px !important;*/
/*}*/

</style>
